// combo-box-helpers.ts

import React from 'react';

const listClassNames = {
  listItemActive: 'list-item-active',
};

export const attachScrollListener = (ref: React.RefObject<HTMLDivElement>, handleScroll: () => void) => {
  const parentNode = ref?.current?.parentNode;

  if (parentNode && parentNode instanceof HTMLElement) {
    // Attach the scroll listener to the parent node
    parentNode.addEventListener('scroll', handleScroll);

    // Return a cleanup function to remove the event listener
    return () => {
      parentNode.removeEventListener('scroll', handleScroll);
    };
  } else {
    return undefined;
  }
};

export const scrollSelectedItem = (refSelect: React.RefObject<HTMLDivElement>, behavior: ScrollBehavior = 'smooth') => {
  const selector: string = `.${listClassNames.listItemActive}`;
  const selected: Element | null | undefined = refSelect.current?.querySelector(selector);

  // Don't mock WINDOW global functions for testing, "scrollIntoView" will be probably moved to WebApp
  /* istanbul ignore if */
  if (selected && typeof selected.scrollIntoView === 'function') {
    selected.scrollIntoView({
      behavior,
      block: 'nearest',
    });
  }
};
